import "./Roles.css";

import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import {
  Box,
  Button,
  Collapsible,
  ColumnConfig,
  DataTable,
  Menu,
  Header,
  InfiniteScroll,
  KeyPress,
  Layer,
  List,
  MouseClick,
  Spinner,
  Text,
  TextInput,
} from "grommet";
import { RoleType } from "./types/RoleType";
import rolesService from "./roles.service";
import { PermissionType } from "../Permissions/types/PermissionType";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { useErrorHandler } from "../../../common/context/ErrorStore";
// import RightSidebar from "../../../common/right-sidebar/RightSidebar";

import { PermissionTableStateType } from "../Users/types/PermissionTableStateType";
import permissionsService from "../Permissions/permissions.service";
import useLongPress from "../../../common/util/LongPress";
import ConfirmationDialog from "../../../common/confirmation-dialog/ConfirmationDialog";
import { RoleTableColumns } from "./components/RoleTableColumns";
import { PermissionTableColumns } from "../Permissions/components/PermissionTableColumns";
import { RightSidebarStateType } from "../../../common/right-sidebar/types/RightSidebarStateType";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { Mixpanel } from "../../../../../../util/Helper";
import CreateRolesBar from "./CreateRolesBar";
import EditRolesBar from "./EditRolesBar";
import { RoleStore } from "../../../../../../store/RoleStore";
import userActionDropdown1 from "../../../../../../assets/arrow_drop_down.svg";
import noResult from "../../../../../../assets/no-result.png";
import { MenuItemProps } from "@aws-amplify/ui-react";
import RightSidebar from "../../../common/right-sidebar/RightSidebar";
import DisableRightBar from "../../../common/right-sidebar/DisableRightBar";
import CommonButton from "../../../common/Button/CommonButton";
import CommonSearchInput from "../../../common/SearchInput/CommonSearchInput";
import Pagination from "../../../common/Pagination/Pagination";

const Roles = observer(() => {
  const { rootStore } = useStore();
  const [roles, setRoles] = useState([] as RoleType[]);
  const [originalRoleList, setOriginalRoleList] = useState([] as RoleType[]);
  const [showPopup, setShowPopup] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const [clickedRole, setClickedRole] = useState({} as RoleType);
  const [selectedRoles, setSelectedRoles] = useState<(string | number)[]>([]);
  const [
    showRightSidebarPermissionSelection,
    setShowRightSidebarPermissionSelection,
  ] = useState(false);
  const [permissionTableState, setPermissionTableState] =
    useState<PermissionTableStateType>({} as PermissionTableStateType);
  const [onSelectTriggerred, setOnSelectTriggered] = useState(false);
  const [selectionActivated, setSelectionActivated] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [rightSidebarPermissionsState, setRightSidebarPermissionsState] =
    useState({} as RightSidebarStateType<(string | number)[]>);

  const navigate = useNavigate();

  useEffect(() => {
    rootStore.loadingStore.setShowLoader(true);
    rolesService
      .listAllRoles()
      .then((_roles) => {
        rootStore.adminStore.handleRoles(_roles);
         setOriginalRoleList(_roles);
         rootStore.loadingStore.setShowLoader(false);
      })
      .catch((e: AxiosError) => {
        if (e.message.includes("403")) {
          rootStore.errorHandlingStore.displayError(
            "ERROR: User not authorized"
          );
        }
      });
  }, [rootStore.roleStore.getupdates]);

  useEffect(() => {
    if (rootStore.adminStore.getOnSelectTrigger) {
      rootStore.adminStore.handleOnSelectTrigger(false);
      rootStore.adminStore.handleShowPopUp(false);
    }
  }, [rootStore.adminStore.getOnSelectTrigger]);

  useEffect(() => {
    console.log("selectedRoles: ", toJS(rootStore.adminStore.getSelectedRoles));
  }, [rootStore.adminStore.getSelectedRoles]);

  const columns = useMemo(() => {
    return RoleTableColumns;
  }, []);

  useEffect(() => {
    setRoles(rootStore.adminStore.getRoles);
  }, [List, rootStore.adminStore.getRoles]);

  const onSearchStrChange = (value: string) => {
    setSearchString(value);
    if (value.trim() === "") {
      rootStore.adminStore.handleRoles(originalRoleList);
    }
  };

  const onSearch = (value: string) => {
    const filteredRole = originalRoleList.filter((item) => {
      return (
        item.code.toLowerCase().includes(value.toLowerCase()) ||
        item.displayName.toLowerCase().includes(value.toLowerCase())
      );
    });
    console.log("filteredRole", filteredRole);
    rootStore.adminStore.handleRoles(filteredRole);
    setCurrentPage(1);
  };

  const assignPermission = (permissions: (string | number)[]) => {
    console.log(
      "selected roles for assigning permissions: ",
      toJS(rootStore.adminStore.getSelectedRoles)
    );
    if(!permissions.length){
      rootStore.errorHandlingStore.displayError(
        "Please select at least 1 permission!"
      );
      return
    }
    rolesService
      .assignPermissions(
        rootStore.adminStore.getSelectedRoles as string[],
        permissions as string[]
      )
      .then((res) => {
        rootStore.notificationToastStore.showNotification(
          "Assigned selected permissions to the roles",
          false,
          3000
        );
        rootStore.adminStore.handleRightSidebarPermission(false);
      })
      .catch((error) => {
        if (error instanceof AxiosError)
          rootStore.errorHandlingStore.displayError(error.message);
        // else rootStore.errorHandlingStore.displayError("error occured while assigning permissions");
        rootStore.notificationToastStore.showNotification(
          "error occured while assigning permissions",
          true,
          3000
        );
      });
  };

  const revokePermissions = useCallback(
    (permissions: (string | number)[]) => {
      if(!permissions.length){
        rootStore.errorHandlingStore.displayError(
          "Please select at least 1 permission!"
        );
        return
      }
      rolesService
        .revokePermissions(
          rootStore.adminStore.getSelectedRoles[0] as string,
          permissions as string[]
        )
        .then((res) => {
          rootStore.notificationToastStore.showNotification(
            "Revoked selected permissions",
            false,
            3000
          );
          rootStore.adminStore.handleRightSidebarPermission(false);
        })
        .catch((error) => {
          console.log("error", error);

          if (error instanceof AxiosError) {
            rootStore.errorHandlingStore.displayError(error.message);
          }
          // rootStore.errorHandlingStore.displayError("error occured while assigning permissions");
          else
            rootStore.notificationToastStore.showNotification(
              "error occured while revoke permissions",
              true,
              3000
            );
        });
    },
    [rootStore.adminStore.getSelectedRoles]
  );

  const openPermissionSelection = useCallback(async () => {
    let uInfos = localStorage.getItem("userinfo");
    if (uInfos) {
      const userinformation = JSON.parse(uInfos);

      Mixpanel.track("web_role_assign_permission_click", {
        name: userinformation.username,
      });
    }
    // Get list of permissions
    // Prepare columns
    // display selection sidebar
    try {

      const permissions: PermissionType[] =
        await permissionsService.listAllPermissions();
      const columns = PermissionTableColumns;
      rootStore.adminStore.handlePermissionTableState({
        data: permissions,
        columns: columns,
      });
      rootStore.adminStore.handleRightSidebarPermissionState({
        title: "Select Permissions to Assign",
        description:
          "Please select all the permission you want to assign to the selected roles.",
        onSubmit: assignPermission,
        submitButtonTitle: "Assign Permissions",
        tableTitle: "Permissions",
      });
      // alert("hhuh")
      rootStore.adminStore.handleRightSidebarPermission(true);
      rootStore.roleStore.setRolesActionMenu();
   
    } catch (error) {
      if (error instanceof AxiosError) {
        rootStore.errorHandlingStore.displayError(error.message);
      } else {
        // rootStore.errorHandlingStore.displayError("unable to get permission, please reload the page!");
        rootStore.notificationToastStore.showNotification(
          "unable to get permission, please reload the page!",
          true,
          3000
        );
      }
    }
  }, [assignPermission]);

  const openPermissionRevokeSelection = useCallback(async () => {
    let uInfos = localStorage.getItem("userinfo");
    if (uInfos) {
      const userinformation = JSON.parse(uInfos);

      Mixpanel.track("web_role_revoke_permission_click", {
        name: userinformation.username,
      });
    }

    // Get list of permissions
    // Prepare columns
    // display selection sidebar
    try {

      const permissions: PermissionType[] =
        await rolesService.listAllPermissionsByRole(
          rootStore.adminStore.getSelectedRoles[0] as string
        );

      const columns = PermissionTableColumns;
      rootStore.adminStore.handlePermissionTableState({
        data: permissions,
        columns: columns,
      });
      rootStore.adminStore.handleRightSidebarPermissionState({
        title: "Select Permissions to Revoke",
        description:
          "Please select all the permission you want to remove from the selected role.",
        onSubmit: revokePermissions,
        submitButtonTitle: "Revoke",
        tableTitle: "Permissions",
      });
      rootStore.adminStore.handleRightSidebarPermission(true);
      rootStore.roleStore.setRolesActionMenu();
    
    } catch (error) {
      if (error instanceof AxiosError) {
        rootStore.errorHandlingStore.displayError(error.message);
      } else {
        rootStore.errorHandlingStore.displayError(
          "unable to get permission, please reload the page!"
        );
      }
    }
  }, [rootStore.adminStore.getSelectedRoles, revokePermissions]);

  const onRolesRowClicked = async (
    event: MouseClick<RoleType> | KeyPress<RoleType>
  ) => {
    const permissionsForRole: PermissionType[] =
      await rolesService.getPermissionsByRole(event.datum.code);
    const columns = PermissionTableColumns;
    rootStore.adminStore.handlePermissionTableState({
      data: permissionsForRole,
      columns: columns,
    });
    rootStore.adminStore.handleRightSidebarPermissionState({
      title: "Role - " + event.datum.code,
      description:
        "Create new role using this role as a template. Doing this all the permissions of this role will be copied to the new role.",
      onSubmit: () => {
        navigate("/create-role", {
          state: {
            ...event.datum,
            permissions: permissionsForRole,
          },
        });
      },
      submitButtonTitle: "Next",
      tableTitle: "Permissions",
      itemsNotSelectable: true,
    });
    rootStore.adminStore.handleRightSidebarPermission(true);
    // setShowPopup(true);
    // setClickedRole({
    //   ...event.datum,
    //   permissions: permissionsForRole,
    // });
  };

  // configure long press on table row
  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500,
  };
  //  const longPressEvent = useLongPress(
  //    () => {
  //      rootStore.adminStore.handleSelectedActivation(true);
  //    },
  //    () => {},
  //    defaultOptions
  //  );
  // const defaultOptions = {
  //   shouldPreventDefault: true,
  //   delay: 500,
  // };
  // const longPressEvent = useLongPress(
  //   () => {
  //     rootStore.adminStore.handleSelectedActivation(true);
  //   },
  //   () => {},
  //   defaultOptions
  // );

  const showCreateRoles = () => {
    let uInfos = localStorage.getItem("userinfo");
    if (uInfos) {
    const userinformation = JSON.parse(uInfos);
    Mixpanel.track("web_create_role_button_click",{name: userinformation?.username});
    }
    rootStore.adminStore.handleRolesShowCloseButton(true);
    // rootStore.roleStore.setRolesActionMenu()
  };
  interface MenuItem {
    label: string;
    onClick: () => void;
    disabled?: boolean;
  }

  const menuItems: MenuItem[] = [
    {
      label: "Assign Permissions",
      onClick: openPermissionSelection,
    },
    {
      label: "Revoke Permissions",
      onClick: openPermissionRevokeSelection,
    },
    {
      label:
        rootStore.roleStore.getSelectedRoles.length > 1
          ? "Delete Roles"
          : "Delete Role",
      onClick: () => {
        let uInfos = localStorage.getItem("userinfo");
        if (uInfos) {
        const userinformation = JSON.parse(uInfos);
        Mixpanel.track("web_delete_role_button_click",{name: userinformation?.username});
        }
        rootStore.adminStore.handleDeleteConformation(true);
        rootStore.roleStore.setRolesActionMenu();
      },
    },
  ];
  // {
  //   label: "Assign Permissions",
  //   onClick: assignPermission,
  // },
  // ...(rootStore.adminStore.getSelectedusers.length === 1
  //   ? [
  //       {
  //         label: "Revoke Permissions",
  //         onClick: revokePermissions,
  //       },
  //     ]
  //   : []),
  // // {
  // //   label: "Assign Roles",
  // //   onClick: assignRoles,
  // // },
  // ...(rootStore.roleStore.getSelectedRoles.length === 1
  //   ? [
  //       {
  //         label: "Revoke Roles",
  //         onClick: revokeRoles,
  //       },
  //     ]
  //   : []),
  //   {
  //         label:
  //        rootStore.roleStore.getSelectedRoles.length > 1
  //             ? "Disable Users"
  //             : "Disable User",
  //         onClick: () => {
  //           Mixpanel.track("web_disable_user_click");
  //           rootStore.adminStore.handleUserShowDisableConfirmation(true);
  //           rootStore.roleStore.setRolesActionMenu()
  //         },
  //       },
  // ]
  const    menuListItem = menuItems.map((item) => {
    return <li onClick={item.onClick}>{item.label}</li>;
  });
  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleOrgList = rootStore.adminStore.getRoles.slice(
    
    startIndex,
    endIndex
  );

  // key down
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      onSearch(searchString); // Call onSearch function when Enter key is pressed
    }
  };
  const totalItems = rootStore.adminStore.getRoles.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);



  // Handle outside click
  const actionMenuRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (actionMenuRef.current && !actionMenuRef.current.contains(event.target as Node)) {
        rootStore.roleStore.setRolesActionMenu(); // Toggle the dropdown (assuming it toggles the state)
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  

  return (
    <Box className="role-screen-container">
      <Box className="role-screen-main-content" style={{height: '100%'}}>
        <div className="role-screen-header">
          <div className="role-screen-left-header">
            <CommonSearchInput
              onkeydown={(e: any) => handleKeyDown(e)}
              onchange={(e: any) => onSearchStrChange(e.target.value)}
            />
            <CommonButton
              title="Search"
              padding="10px 24px 10px 28px"
              color="#fff"
              bgColor="#357EFF"
              radius={10}
              border="1px solid #357EFF"
              lineheight="14px"
              ml={5}
              onclick={() => onSearch(searchString)}
            />
          </div>

          <div className="role-screen-right-header">
            <Button
              style={{
                color: "#FFF",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "16px",
                // display: "flex",
                padding: "10px 14px",
                justifyContent: "flex-end",
                alignItems: "center",
                alignSelf: "flex-start",
                borderRadius: "10px",
                border: "1px solid #357EFF",

                background: "#357EFF",
              }}
              primary
              color={"brand-1"}
              label="Create Role"
              onClick={showCreateRoles}
            />
            {true ? (
              <>
                {/* <Button
                 color={"brand-1"}
                label="Assign Permissions"
                onClick={openPermissionSelection}
              /> */}
                <Box
                  className="user-action-list-outer"
                  style={{ position: "relative" }}
                >
                  {/* <CommonButton
  title="Action"
  padding="8px 12px"
  color="#4B628A"
  bgColor="#E9F2FF"
  width="148px"
  height="41px"
  radius={10}
  lineheight="14px"
  ml={5}
  onclick={() => rootStore.adminStore.setUsersActionMenu() }
>
  <img
    style={{
      width: "24px",
      height: "24px",
      flexShrink: "0",
    }}
    src={userActionDropdown}
    alt="Dropdown Icon"
  />
 </CommonButton> */}
                  <Button
                    className="users-action-btn"
                    // disabled={rootStore.roleStore.getSelectedRoles.length > 0 ? false : true}
                    disabled={
                      rootStore.adminStore.getSelectedRoles.length > 0
                        ? false
                        : true
                    }
                    onClick={() => rootStore.roleStore.setRolesActionMenu()}
                  >
                    Action
                    <img
                      className={
                        rootStore.roleStore.getRolesActionMenu
                          ? "rotate180"
                          : "rotate0"
                      }
                      style={{
                        width: "24px",
                        height: "24px",
                        flexShrink: "0",
                      }}
                      src={userActionDropdown1}
                      alt="Dropdown Icon"
                    />
                  </Button>
                  {rootStore.roleStore.getRolesActionMenu && (
                    <ul className="action-list" ref={actionMenuRef}>
                      {menuListItem}
                      {/* <li>TestProgram</li> */}
                    </ul>
                  )}
                </Box>
                {/* <Menu
                label="Actions"
                items={[
                  [
                    {
                      label: "Assign Permissions",
                      onClick: openPermissionSelection,
                    },
                    ...(rootStore.adminStore.getSelectedRoles.length === 1
                      ? [
                          {
                            label: "Revoke Permissions",
                            onClick: openPermissionRevokeSelection,
                          },
                        ]
                      : []),
                  ],
                  [
                    {
                      label:
                      rootStore.adminStore.getSelectedRoles.length > 1
                          ? "Delete Roles"
                          : "Delete Role",
                      onClick: () => {
                        let uInfos = localStorage.getItem("userinfo");
              if(uInfos)
                {
              const userinformation = JSON.parse(uInfos);
                        Mixpanel.track("web_delete_role_button_click",{name:userinformation.username});
                }
                        rootStore.adminStore.handleDeleteConformation(true);
                      },
                    },
                  ],
                 ]}
               /> */}
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        {/* <p className="message-text">
           Click and hold on the table to select roles and assign permissions
         </p> */}

        <Box className={visibleOrgList.length > 0 ? "scrollbar-table" : ""}>
          <DataTable
            className="role-screen-datatable"
            columns={columns}
            data={visibleOrgList}
            resizeable
            step={itemsPerPage}
            select={rootStore.adminStore.getSelectedRoles}
            onSelect={(items) => {
              rootStore.adminStore.handleSelectedRoles(items);
              rootStore.adminStore.handleOnSelectTrigger(true);
            }}
          />
        </Box>
        {
          visibleOrgList.length == 0 && (<Box className="no-result-img">
              <img src={noResult} alt="no emergency found" />
              <p>No Data Found.</p>
            </Box>)
        }

      </Box>

      {rootStore.adminStore.getRightSidebarPermission ? (
        <RightSidebar
          {...rootStore.adminStore.getRightSidebarPermissionState}
          onCancel={() =>
            rootStore.adminStore.handleRightSidebarPermission(false)
          }
          tableData={rootStore.adminStore.getPermissionTableState.data}
          columns={rootStore.adminStore.getPermissionTableState.columns}
          showSubmitButton={true}
        />
      ) : (
        <></>
      )}
      {rootStore.adminStore.getDeleteConformation ? (
        <DisableRightBar
          show={rootStore.adminStore.getDeleteConformation}
          onCancel={() => {
            let uInfos = localStorage.getItem("userinfo");
            if (uInfos) {
              const userinformation = JSON.parse(uInfos);
              Mixpanel.track("web_delete_role_cancel_click", {
                name: userinformation.username,
              });
            }
            rootStore.adminStore.handleDeleteConformation(false);
          }}
          onDone={async () => {
            let uInfos = localStorage.getItem("userinfo");
            if (uInfos) {
              const userinformation = JSON.parse(uInfos);
              Mixpanel.track("web_delete_role_submit_click", {
                name: userinformation.username,
              });
            }
            try {
              // alert(JSON.stringify(rootStore.adminStore.getSelectedRoles))
              await rolesService.deleteRoles(
                rootStore.adminStore.getSelectedRoles as string[]
              );
              // alert(JSON.stringify(rootStore.adminStore.getSelectedRoles))
              rootStore.notificationToastStore.showNotification(
                "Roles deleted!",
                false,
                3000
              );
              rolesService
                .listAllRoles()
                .then((roles) => rootStore.adminStore.handleRoles(roles));
              // alert(JSON.stringify(roles))
            } catch (e) {
              console.log("error deleting: ", e);
              if (e instanceof AxiosError) {
                if (e.response != null) {
                  if (
                    e.response.data === "STANDARD_ROLE_DELETION_NOT_ALLOWED"
                  ) {
                    rootStore.errorHandlingStore.displayError(
                      "Standard role cannot be deleted"
                    );
                  } else {
                    rootStore.notificationToastStore.showNotification(
                      "Role deletion failed! Remove any permission assigned to this role before deletion.",
                      true,
                      3000
                    );
                    // rootStore.errorHandlingStore.displayError(
                    //   "Role deletion failed! Remove any permission assigned to this role before deletion."
                    // );
                  }
                } else {
                  rootStore.errorHandlingStore.displayError(e.message);
                }
              } else {
                rootStore.errorHandlingStore.displayError(
                  "Error occured while deleting roles."
                );
              }
            }
            rootStore.adminStore.handleDeleteConformation(false);
            // alert(JSON.stringify(rootStore.adminStore.handleDeleteConformation))
          }}
          confimButtonText="Delete"
          title="Are you sure to delete the roles?"
          typingValidationText="delete"
        />
      ) : (
        <></>
      )}
      {/* {rootStore.adminStore.getCreateRolesModal ? (
        <RightSidebar
          {...rootStore.adminStore.getRightSidebarPermissionState}
          onCancel={() => rootStore.adminStore.handleCreateRolesModal(false)}
          tableData={rootStore.adminStore.getPermissionTableState.data}
          columns={rootStore.adminStore.getPermissionTableState.columns}
          showSubmitButton={true}
        />
      ) : (
        <></>
      )} */}
      {rootStore.adminStore.getRolesShowCloserConfirmation ? (
        <CreateRolesBar />
      ) : (
        // {...rootStore.adminStore.getRightSidebarPermissionState}
        // onCancel={() => rootStore.adminStore.handleCreateRolesModal(false)}
        // tableData={rootStore.adminStore.getPermissionTableState.data}
        // columns={rootStore.adminStore.getPermissionTableState.columns}
        // showSubmitButton={true}

        <></>
      )}
      {rootStore.adminStore.getEditRoles ? (
        <EditRolesBar />
      ) : (
        // {...rootStore.adminStore.getRightSidebarPermissionState}
        // onCancel={() => rootStore.adminStore.handleCreateRolesModal(false)}
        // tableData={rootStore.adminStore.getPermissionTableState.data}
        // columns={rootStore.adminStore.getPermissionTableState.columns}
        // showSubmitButton={true}

        <></>
      )}
      {/* <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(
          rootStore.adminStore.getRoles.length / itemsPerPage
        )}
        totalItems={rootStore.adminStore.getRoles.length}
        onPageChange={handlePageChange}
      /> */}
         {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          onPageChange={handlePageChange}
        />
      )}
      {/* <ConfirmationDialog
         show={rootStore.adminStore.getDeleteConformation}
         onCancel={() => {
          Mixpanel.track("web_delete_role_cancel_click");
          rootStore.adminStore.handleDeleteConformation(false);
        }}
        onDone={async () => {
          Mixpanel.track("web_delete_role_submit_click");
          try {
            await rolesService.deleteRoles(rootStore.adminStore.getSelectedRoles as string[]);

            rootStore.notificationToastStore.showNotification("Roles deleted!",false, 3000);

            rolesService.listAllRoles().then((roles) => rootStore.adminStore.handleRoles(roles));
          } catch (e) {
            console.log("error deleting: ", e);
            if (e instanceof AxiosError) {
              if (e.response != null) {
                if (e.response.data === "STANDARD_ROLE_DELETION_NOT_ALLOWED") {
                  rootStore.errorHandlingStore.displayError("Standard role cannot be deleted");
                } else {
                  rootStore.errorHandlingStore.displayError(
                    "Role deletion failed! Remove any permission assigned to this role before deletion."
                  );
                }
              } else {
                rootStore.errorHandlingStore.displayError(e.message);
              }
            } else {
              rootStore.errorHandlingStore.displayError("Error occured while deleting roles.");
            }
          }
          rootStore.adminStore.handleDeleteConformation(false);
        }}
        confimButtonText="Delete"
        title="Are you sure to delete the roles?"
        typingValidationText="delete"
      /> */}
    </Box>
  );
});

export default Roles;
